import {
  Complementary,
  GetProps,
  ProductDetails,
  Similar,
  SubSDK,
  Tags,
} from "../types";
import { GetProductByIdQuery } from "./queries/product";
import { GraphqlClient } from "@/utils/graphql";
export interface HeliumInfo {
  apiKey: string;
  version: 1 | 2;
  shopify: {
    shop: string;
    storefrontAccessToken: string;
  };
}
interface ShopifyProduct {
  tags: Tags;
  similar: Similar;
  complementary?: Complementary;
  title: string;
  description: string;
  handle: string;
  featuredImage: {
    src: string;
    width: number;
    height: number;
    altText: string;
  };
}
export interface HeliumProduct {
  title: string;
  description: string;
  handle: string;
  featuredImage: {
    src: string;
    width: number;
    height: number;
    altText: string;
  };
}
const apiUrl = "https://d21xluao80us9l.cloudfront.net";

export class HeliShop implements SubSDK<HeliumInfo> {
  info: HeliumInfo;
  private fetcher: <T = any>(path: string, options?: RequestInit) => Promise<T>;
  private shopifyFetcher: GraphqlClient;
  constructor(props: HeliumInfo) {
    this.info = props;

    this.fetcher = async (path: string, options?: RequestInit) => {
      const orgId = window.helium.brandData.orgId;
      const [, type, handle] = path.split("/");
      const storeId = window.helium.brandData.storeId;
      let useStoreId = true;
      if (type === "similar" || type === "complementary") {
        useStoreId = true && storeId;
        if (typeof window.helium.brandData.useStoreId === "boolean") {
          useStoreId = window.helium.brandData.useStoreId;
        }
      }
      if (type === "tags" || type === "details") {
        useStoreId = false;
      }
      if (type === "products") {
        useStoreId = true;
        const res = await fetch(
          apiUrl +
            `/${orgId}/products/${type}.${useStoreId ? `${storeId}.` : ""}json`,
          {
            ...options,
            headers: { "x-helium-api-key": this.info.apiKey },
          },
        );
        return res.json();
      }
      const res = await fetch(
        apiUrl +
          `/${orgId}/products/${handle}/${type}.${useStoreId ? `${storeId}.` : ""}json`,
        {
          ...options,
          headers: { "x-helium-api-key": this.info.apiKey },
        },
      );
      return res.json();
    };

    this.shopifyFetcher = new GraphqlClient({
      shop: props.shopify.shop,
      storefrontAccessToken: props.shopify.storefrontAccessToken,
    });
  }
  async getProductByHandle(props: { handle: string }): Promise<undefined> {}

  async getTags({ id }: GetProps) {
    return (await this.fetcher("/tags/" + id)) || {};
  }

  async getProductDetails({ id }: GetProps) {
    const data = await this.shopifyFetcher.request<{
      product: ShopifyProduct;
    }>(GetProductByIdQuery, {
      handle: id,
    });
    if (data.product) {
      const tempProduct = data.product;
      const finalProduct = {
        ...tempProduct,
        images: tempProduct.images.edges.map((edge) => edge.node.originalSrc),
        variants: tempProduct.variants.edges.map((edge) => edge.node),
        image: tempProduct.featuredImage.src,
      };
      return finalProduct as unknown as ProductDetails;
    } else {
      const product = await this.fetcher("/details/" + id);
      return {
        ...product,
        images: [product.image],
      };
    }
    return {} as ProductDetails;
  }

  async getSimilar({ id }: GetProps) {
    return await this.fetcher("/similar/" + id);
  }
  async getFaq({ id }: GetProps) {
    const orgId = window.helium.brandData.orgId;
    const storeId = window.helium.brandData.storeId;
    const path = `${apiUrl}/${orgId || storeId}/products/${id}/faq.json`;
    // const res = await fetch(`${apiUrl}/api/v1/faq/${id}.`, {
    //   headers: { "x-helium-api-key": this.info.apiKey },
    // });
    // return res.json();
    const res = await fetch(path).then((r) => r.text());
    return JSON.parse(res);
  }

  async getComplementary({ id }: GetProps) {
    return (await this.fetcher("/complementary/" + id)) || [];
  }
  async getProducts() {
    return (await this.fetcher("/products")) || [];
  }
}
